var EnergyWidget = function () {

    component = $('[data-component="energy-widget"]');
    pointsTemplate = $('[data-template="points-container"]').html();
    poinstTarget = $('[data-component="energy-points"]');
    scrollAnimation = false;

    function init() {

        getPointsList();
        addEvents();
        modal = new EnergyModal();
    }

    function scrolling() {

        var mainImg = $('[data-component="energy-widget"]').find(".box-img-energy .main-image");
        var container = $(".container-img-energy");

        if (mainImg.width() > $(".box-img-energy").width()) {

            $(".btn_dir").css("display", "block");
        }

        $(".btn_dir").click(function () {

            if (!EnergyWidget.scrollAnimation) {

                var imgLeft = parseInt(container.css("left"));
                var imgWidth = parseInt(mainImg.width());
                var containerWidth = parseInt($(".box-img-energy").width()) - 70;

                imgLeft = imgLeft - containerWidth;

                if ((Math.abs(imgLeft) + containerWidth) > imgWidth) {
                    imgLeft = (imgWidth - containerWidth) * -1;
                }

                if (Math.abs(imgLeft) + containerWidth == imgWidth) {
                    $(".btn_dir").css("display", "none");
                };

                EnergyWidget.scrollAnimation = true;

                container.animate({
                    left: imgLeft
                }, 1000, function () {
                    EnergyWidget.scrollAnimation = false;
                });

                $(".btn_esq").css("display", "block");
            }
        });

        $(".btn_esq").click(function () {

            if (!EnergyWidget.scrollAnimation) {

                var imgLeft = parseInt(container.css("left"));
                var imgWidth = parseInt(mainImg.width());
                var containerWith = parseInt($(".box-img-energy").width()) - 70;

                imgLeft = imgLeft + containerWith;

                if (imgLeft >= 0) {
                    imgLeft = 0;
                    $(".btn_esq").css("display", "none");
                }

                EnergyWidget.scrollAnimation = true;

                container.animate({
                    left: imgLeft
                }, 1000, function () {
                    EnergyWidget.scrollAnimation = false;
                });

                $(".btn_dir").css("display", "block");
            }
        });
    }

    function addEvents() {

        component.on('click', '[data-point-id]', function () {

            modal.getPointDetail($(this).data().pointId);

            $('main').append('<div id="modal-bg-hidden"></div>');

            setTimeout(function () {
                $("#modal-bg-hidden").remove();
            }, 1000);
        });

        component.on({
            mouseenter: function () {

                var pointId = $(this).data('point-id');
                $('.energy-hover[data-point-id="' + pointId + '"]').css("display", "block");
                $('.energy-tooltip[data-point-id="' + pointId + '"]').css("display", "block");
            },
            mouseleave: function () {

                var pointId = $(this).data('point-id');
                $('.energy-hover[data-point-id="' + pointId + '"]').css("display", "none");
                $('.energy-tooltip[data-point-id="' + pointId + '"]').css("display", "none");
            }
        }, ".btn-energy");
    }

    function getPointsList() {

        $.ajax({
            type: 'GET',
            url: '/umbraco/surface/Widget/GetWidget',
            data: { "ComponentID": $("[data-component='energy-widget']").data("id") },
            dataType: "json",
            async: true,
            contentType: "application/json; charset=utf-8",
            beforeSend: function () {
                //MOSTRA O PRELOADER
                console.log('Carregando...');
            },
            success: function (data) {
                //MOSTRA O PRELOADER
                console.log('Carregado!');

                points = { points: data };

                //Renderiza o template, e adiciona no html
                poinstTarget.html(renderPointsList(points));

                var mainImage = $('[data-component="energy-widget"]').find(".box-img-energy .main-image");
                mainImage.on('load', function () {
                    scrolling();
                });
            }
        });
    }

    function renderPointsList(points) {

        return Mustache.render(pointsTemplate, points);
    }

    return init();
}